// extracted by mini-css-extract-plugin
export default {"main_div":"home_main_div__kEFOZ","left_div":"home_left_div__smLIQ","greenhouse":"home_greenhouse__fzEkl","right_div":"home_right_div__OjrvC"};